import PadraoModel from 'src/core/model/PadraoModel.js'

export default class IcarrosAcessorioModel extends PadraoModel {
  recurso = 'icarros/acessorios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Acessórios Icarros';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
